import { useEffect, useRef, useState } from 'react';
import { Link, Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const LinkField = (props: FieldProps) => {
  const { getValue } = useFieldHelper<string>({ source: props.source });
  const value = getValue();
  const linkRef = useRef<HTMLAnchorElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = linkRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [value]);

  if (!value) {
    return <Typography variant="body1">{EMPTY_VALUE_INDICATOR}</Typography>;
  }

  const linkElement = (
    <Link
      ref={linkRef}
      href={value}
      target="_blank"
      rel="noreferrer"
      variant="body1"
      noWrap
      sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      {value}
    </Link>
  );

  if (!isTruncated) {
    return linkElement;
  }

  return (
    <Tooltip title={value} placement="bottom">
      <span>{linkElement}</span>
    </Tooltip>
  );
};

export default LinkField;
